import {
  Button,
  ColorInput,
  ContrastChecker,
  Description,
  Header,
  Modal,
  ValidationStates
} from '@opengov/component-library/dist';
import Color from 'color';
import React from 'react';

import { IReportLocale } from '../../../locale';

import styles from './ColorControlsModal.scss';
import { CustomPicker } from './CustomPicker';

export interface IColorControlsModalProps {
  reportLocaleText: IReportLocale;
  color: string;
  onClose(): void;
  onSave(color: string): void;
}

export interface IColorControlsModalState {
  color: string;
  showColorInputError: boolean;
}

export class ColorControlsModal extends React.Component<IColorControlsModalProps, IColorControlsModalState> {
  constructor(props) {
    super(props);

    this.state = {
      color: props.color,
      showColorInputError: false
    };
  }

  validateColorHexCode = (color) => {
    try {
      Color(color);
      this.setState({ showColorInputError: false });
    } catch (_err) {
      this.setState({ showColorInputError: true });
    }
  };

  handleColorInputChange = (color) => {
    this.setState({ color, showColorInputError: false });
  };

  handleColorPickerChange = (color) => {
    this.setState({ color: color.hex, showColorInputError: false });
  };

  handleColorInputOnBlur = () => {
    this.validateColorHexCode(this.state.color);
  };

  handleSave = () => {
    if (!this.state.showColorInputError) {
      this.props.onSave(this.state.color);
    }
  };

  render() {
    return (
      <Modal.Work width="default" onClose={this.props.onClose}>
        <div className={styles.header}>
          <Header variant="h2">{this.props.reportLocaleText.colorControlsModal.title}</Header>
          <Description>{this.props.reportLocaleText.colorControlsModal.description}</Description>
        </div>
        <div className={styles.body}>
          <div className={styles.bodyLeft}>
            <div className={styles.colorInput}>
              <ColorInput
                color={this.state.color}
                onChange={this.handleColorInputChange}
                onBlur={this.handleColorInputOnBlur}
                validationState={this.state.showColorInputError && ValidationStates.Error}
              />
            </div>
            {this.state.color && <ContrastChecker color={this.state.color} />}
          </div>
          <div className={styles.bodyRight}>
            <div className={styles.colorPicker}>
              <CustomPicker color={this.state.color} onChange={this.handleColorPickerChange} />
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          <Button onClick={this.props.onClose} dataTest="close-btn">
            {this.props.reportLocaleText.cancel}
          </Button>
          <Button
            variant="primary"
            onClick={this.handleSave}
            dataTest="save-btn"
            disabled={this.state.showColorInputError}
          >
            {this.props.reportLocaleText.apply}
          </Button>
        </div>
      </Modal.Work>
    );
  }
}
